"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _utils = require("../../utils");

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UISelectableButton = _interopRequireDefault(require("UIComponents/button/UISelectableButton"));

var _links = require("self-service-api/core/utilities/links");

var _trials = require("ui-addon-upgrades/_core/common/constants/trials");

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var LANG_ROUTE = 'upgrades.activationModal';

var TrialRedirectSurvey = function TrialRedirectSurvey(_ref) {
  var upgradeData = _ref.upgradeData,
      upgradeProduct = _ref.upgradeData.upgradeProduct;
  var surveyOptions = (0, _react.useMemo)(function () {
    return (0, _utils.shuffle)(_trials.SURVEY_OPTIONS_BY_UPGRADE_PRODUCT[upgradeProduct]);
  }, [upgradeProduct]);

  var handleRedirect = function handleRedirect(value) {
    tracker.trackBeforeUnload('trialActivationRedirected', (0, _extends2.default)({
      redirectTarget: value
    }, upgradeData));
    window.location = (0, _links.mapRedirectTargetToRoute)(value, upgradeProduct);
  };

  return _react.default.createElement("div", {
    className: "m-top-6",
    style: {
      width: '100%'
    }
  }, _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
    message: LANG_ROUTE + ".featureExplore"
  })), _react.default.createElement(_UIList.default, null, surveyOptions.map(function (option) {
    return _react.default.createElement(_UISelectableButton.default, {
      className: "m-bottom-2 display-inline-block text-left",
      key: option,
      textLabel: _react.default.createElement(_FormattedMessage.default, {
        message: LANG_ROUTE + ".survey." + option + ".description"
      }),
      block: true,
      name: option,
      truncatable: false,
      onClick: function onClick() {
        return handleRedirect(option);
      }
    });
  }), _react.default.createElement(_UISelectableButton.default, {
    className: "m-bottom-2 display-inline-block text-left",
    textLabel: _react.default.createElement(_FormattedMessage.default, {
      message: LANG_ROUTE + ".survey.other"
    }),
    block: true,
    name: "other",
    truncatable: false,
    onClick: function onClick() {
      return handleRedirect('other');
    }
  })));
};

TrialRedirectSurvey.propTypes = {
  upgradeData: _react.PropTypes.object.isRequired
};
var _default = TrialRedirectSurvey;
exports.default = _default;
module.exports = exports.default;